import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./errorBoundary";
import { Provider } from "react-redux";
import store from "./app/store";
import { KindeWrapper } from "./providers/kindeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <Provider store={store}>
        <KindeWrapper>
          <App />
        </KindeWrapper>
      </Provider>
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
